import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/useAuthStore";

const useLogout = () => {
    const navigate = useNavigate();
    const { clearTokens } = useAuthStore();

    const logout = (redirectTo = "/acceso") => {
        try {
            // Limpiar los tokens del store
            clearTokens();

            // Limpiar cualquier dato adicional del sessionStorage/localStorage
            sessionStorage.removeItem("auth-storage");
            localStorage.removeItem("auth-storage");

            // Navegar a la página especificada
            navigate(redirectTo);

            return { success: true };
        } catch (error) {
            console.error("Error durante el logout:", error);
            // Aún así navegar al login en caso de error
            navigate(redirectTo);
            return { success: false, error };
        }
    };

    const logoutWithConfirmation = (
        message = "¿Estás seguro de que quieres cerrar sesión?",
        redirectTo = "/acceso"
    ) => {
        if (window.confirm(message)) {
            return logout(redirectTo);
        }
        return { success: false, cancelled: true };
    };

    return {
        logout,
        logoutWithConfirmation,
    };
};

export default useLogout;
